import { api } from '@/shared/services/baseApiClient';
import { QueryStringBuilder } from '@/shared/services/queryStringBuilder';
import { Data } from '@/features/reports/models';
import { config } from '@/config/config';
import urljoin from 'url-join';

export interface UsageReportsRequest {
  startDate: Date;
  endDate: Date;
}

export interface UsageReportsData {
  proactiveTriggersTrendReport: Data;
  billableConversationsTrendReport: Data;
  channelMessagesTrendReport: Data;
}

class UsageReportsApi {
  private readonly version = 'v1';

  public loadData(workspaceId: string, request: UsageReportsRequest): Promise<UsageReportsData> {
    const query = new QueryStringBuilder()
      .add('startDate', request.startDate.toISOString())
      .add('endDate', request.endDate.toISOString())
      .build();

    return api.send('GET', urljoin(config().usageHost, this.version, 'workspaces', workspaceId, `reports`) + query);
  }
}

export const usageReportsApi = new UsageReportsApi();
